module.exports = __webpack_public_path__ + "img/icon_sm_cqjssq.e9fc34d8.png";